import { API } from "@/lib/api";

export async function streamChat({ message, threadId, onThread, onDelta, onDone, onError }) {
  const res = await fetch(`${API}/ai/chat`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("fx_token")}`,
      "X-Company-Id": localStorage.getItem("fx_company") || "",
    },
    credentials: "include",
    body: JSON.stringify({ message, thread_id: threadId || null }),
  });
  if (!res.ok || !res.body) {
    onError?.(`AI service unavailable (${res.status})`);
    return;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop() || "";
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      try {
        const payload = JSON.parse(line.slice(5).trim());
        if (payload.thread_id) onThread?.(payload.thread_id);
        if (payload.delta) onDelta?.(payload.delta);
        if (payload.error) onError?.(payload.error);
        if (payload.done) onDone?.();
      } catch (err) {
        console.debug("skipped malformed SSE chunk", err);
      }
    }
  }
  onDone?.();
}
